const ClassName = {
	SHOWED: '_showed',
};

class Toast {
	constructor() {
		this.toastTimeout = null;
		this.init();
	}

	init() {
		document.querySelectorAll('[data-toast-opener]').forEach((button) => {
			button.addEventListener('click', () => {
				const id = button.dataset.toastOpener;
				this.showToast(id);
			});
		});
	}

	showToast(id, text = null) {
		const toast = document.getElementById(id);
		if (toast) {
			this.closeActiveToast();
			this.clearToastTimeout();

			if (text) {
				const textElement = toast.querySelector('.toast__text');
				if (textElement) {
					textElement.textContent = text;
				}
			}

			toast.classList.add(ClassName.SHOWED);

			this.toastTimeout = setTimeout(() => {
				toast.classList.remove(ClassName.SHOWED);
				this.toastTimeout = null;
			}, 1000);
		}
	}

	open(id, text = null) {
		this.showToast(id, text);
	}

	close() {
		this.closeActiveToast();
	}

	closeActiveToast() {
		const activeToast = document.querySelector(`.${ClassName.SHOWED}`);
		if (activeToast) {
			this.clearToastTimeout();
			activeToast.classList.remove(ClassName.SHOWED);
		}
	}

	clearToastTimeout() {
		if (this.toastTimeout) {
			clearTimeout(this.toastTimeout);
			this.toastTimeout = null;
		}
	}
}

export default new Toast();
